import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectQBROfferings = createSelector(
  [selectQbrState],
  (state) => state.documentSettings.offerings
)
